import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";

import moment from "moment";

import Button from "../../components/Button";
import { Card, CardContent } from "../../components/Card";
import { TextInput, DateInput } from "../../components/Form";
import Table from "../../components/Table";

export default function JoinCourse({ simulationQuery }) {
  const datatest = [
    {
      title: "法拍屋入門實戰",
      date: new Date(),
      deposit: "1500",
    },
    {
      title: "法拍屋入門實戰",
      date: moment(new Date()).subtract(7,"days").format("yyyy-MM-DD"),
      deposit: "1500",
    },
    {
      title: "法拍屋入門實戰",
      date: moment(new Date()).subtract(1,"month").format("yyyy-MM-DD"),
      deposit: "1500",
    },
  ];
  const [newData, setNewData] = useState({
    date: null,
  });
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={4} sm={2}>
            <Typography color="primary">客戶編號</Typography>
            <Typography>{simulationQuery.studentID}</Typography>
          </Grid>
          <Grid item xs={4} sm={2}>
            <Typography color="primary">學員姓名</Typography>
            <Typography>{simulationQuery.name}</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
          <Typography color="primary">日期搜尋</Typography>
            <DateInput
              value={newData.date}
              format="yyyy年MM月dd日"
              onChange={(value) => {
                changeData("date", value, true);
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Table
              data={datatest}
              tableWidth={2}
              header={["課程", "課程檔期", "課程訂金", "操作"]}
              columns={[
                "title",
                (item) => moment(item.date).format("yyyy-MM-DD"),
                "deposit",
                (item) => (
                  <Button
                    color="primary"
                    variant="contained"
                    onPress={() => {}}
                  >
                    刪除
                  </Button>
                ),
              ]}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
